import React from "react";
import { useTranslation } from "react-i18next";

const JudgingProcess = () => {
  const { t } = useTranslation();
  const steps = [
    {
      title: "Open Submission",
      description:
        "Participants are required to complete the submission form, which can be downloaded from our website, and then upload the completed form through the same portal.",
    },
    {
      title: "Submission Closed",
      description:
        "Participants are allowed to upload their submission form until 17:00 PM on May 22, 2026.",
    },
    {
      title: "First Assessment",
      description:
        "The judging team will conduct an analysis based on the administrative criteria and prepare the preliminary scoring for review by the judging panel.",
    },
    {
      title: "Second Assessment",
      description:
        "Nominees will be invited to deliver an online presentation, with each session lasting a maximum of 30 minutes, including Q&A.",
    },
    {
      title: "Awarding Night",
      description: "All of the finalist will be invited to the awarding night.",
    },
  ];
  return (
    <div id="judgingProcessContainer">
      <section>
        <div className="space-y-8 app-main-container">
          <p className="text-xl font-bold text-left sm:text-2xl app-animation-translate-start section-title">
            {t("judgingProcess")}
          </p>
          <p className="text-xs sm:text-sm md:text-md lg:text-lg app-animation-translate-start">
            {t("judgingProcessText")}
          </p>
          <div className="relative w-full">
            {/* Arrow for large device */}
            <div className="hidden lg:flex absolute top-[22px] left-0 right-0 h-4 bg-[#2242B2] rounded-r-full items-center">
              {/* Arrowhead */}
              <div className="ml-auto mr-[-12px] w-0 h-0 border-t-[12px] border-t-transparent border-l-[24px] border-l-[#2242B2] border-b-[12px] border-b-transparent"></div>
            </div>

            {/* Arrow for mobile device */}
            <div className="block lg:hidden absolute top-0 left-[22px] bottom-0 w-4 bg-[#2242B2] rounded-b-full">
              <div className="absolute bottom-[-12px] left-1/2 -translate-x-1/2 w-0 h-0 border-l-[12px] border-l-transparent border-t-[24px] border-t-[#2242B2] border-r-[12px] border-r-transparent"></div>
            </div>

            <div className="relative flex flex-col items-start justify-between gap-5 mt-10 lg:flex-row lg:items-center lg:gap-0">
              {steps.map((step, i) => (
                <div
                  key={i}
                  className="flex flex-row sm:flex-row md:flex-row items-start text-left lg:text-center lg:flex-1 min-h-[0px] lg:min-h-[250px] ml-0 lg:ml-2"
                >
                  {/* Circle */}
                  <div className="relative flex flex-col items-center ml-[30px] mt-9 lg:ml-4">
                    <div className="flex items-center justify-center w-8 h-8 bg-blue-800 rounded-full absolute -top-[22px] left-1/2 -translate-x-1/2">
                      <div className="w-3 h-3 rounded-full bg-[#8DC63F]"></div>
                    </div>
                  </div>

                  {/* Text */}
                  <div className="mt-4 ml-8 text-left lg:mt-16 lg:ml-0">
                    <h3 className="mb-1 font-bold text-blue-800 lg:mb-2 text-md">
                      {step.title}
                    </h3>
                    <p className="text-xs leading-relaxed text-gray-700">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default JudgingProcess;
